import React, { useState } from "react";
import Footer from "../Fotter";

function FAQ() {
  // State to track which question is open
  const [openIndex, setOpenIndex] = useState(null);

  // Toggle the answer visibility
  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className="container mx-auto px-4 py-6">
        {/* Shipping Information Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Shipping Information</h2>
          <p className="text-gray-600 mb-2">
          AddMeCart delivers better quality products to meet customer needs.
            We are always committed to providing better customer service to our
            buyers. We offer the widest selection of electronics and other
            products at competitive prices.
          </p>
          <p className="text-gray-600 mb-2">
          AddMeCart is an Indian shopping store! We deliver products pan
            India but do not currently offer international shipping.
          </p>
          <p className="text-gray-600">AddMeCart payment options are:</p>
          <ul className="mt-2 text-gray-600 list-disc pl-6">
            <li>UPI</li>
            <li>Internet Banking</li>
            <li>Credit/Debit Card</li>
          </ul>
        </div>

        {/* FAQ Section */}
        <h1 className="text-3xl font-bold mb-6">Frequently Asked Questions</h1>

        {/* Question 1 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(0)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            {" "}
            Cash On Delivery Available Or Not?
          </button>
          {openIndex === 0 && (
            <p>AddMeCart Don’t Have COD On Any Product Yet!</p>
          )}
        </div>

        {/* Question 2 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(1)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Is The Expected Delivery Time?
          </button>
          {openIndex === 1 && (
            <p className="mt-2 text-gray-600 px-4">
              AddMeCart Deliver Products Within 5-6 Working Days!
            </p>
          )}
        </div>

        {/* Question 3 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(2)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            Why Should I Buy From AddMeCart?
          </button>
          {openIndex === 2 && (
            <ul className="mt-2 text-gray-600 px-4 list-disc">
              <li>
              AddMeCart Deliver Better Quality Products As Customer Needs.
              </li>
              <li>
              AddMeCart Is Always Tries To Give Better Customer Service To
                Their Buyers.
              </li>
              <li>
              AddMeCart Have The Widest Selection Of Electronics Products &
                Others!
              </li>
            </ul>
          )}
        </div>

        {/* Question 4 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(3)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Is Refurbished Product?
          </button>
          {openIndex === 3 && (
            <p className="mt-2 text-gray-600 px-4">
              Refurbishment Is The Distribution Of Products That Have Been
              Previously Returned To A Manufacturer Or Vendor For Various
              Reasons, Not Sold In The Market Or New Launch Of A Product!
            </p>
          )}
        </div>

        {/* Question 5 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(4)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Is Open Box Product?
          </button>
          {openIndex === 4 && (
            <p className="mt-2 text-gray-600 px-4">
              An Item That Is An ‘Open-Box’ Product Has Been Opened Before It
              Was Returned To The Retail Store Or To The Manufacturer!
            </p>
          )}
        </div>

        {/* Question 6 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(5)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            Is There Any Warranty Available On Products?
          </button>
          {openIndex === 5 && (
            <p className="mt-2 text-gray-600 px-4">
              AddMeCart All Products Have Warranties But In Different-different
              Slabs Example All Refurbished Products Have 6 Months – 1 Year
              AddMeCart Warranty They Do Not Have Any Kind Of Company Warranty!
            </p>
          )}
        </div>

        {/* Question 7 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(6)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Is Your Refund And Return Policy?
          </button>
          {openIndex === 6 && (
            <p className="mt-2 text-gray-600 px-4">
              AddMeCart Refund & Return Policies Are Well Mentioned Here –
            </p>
          )}
        </div>

        {/* Question 8 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(7)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            What Should I Do If I Received Damage/Defective OR Wrong Product?
          </button>
          {openIndex === 7 && (
            <p className="mt-2 text-gray-600 px-4">
              First Capture Some Pictures Or Video Of Your Received Product And
              Share With AddMeCart Customer Care If They Found That The Product
              Is Actually Damage/Defective Or Wrong; Then The Product Will Be
              Replaced As Soon As Possible!
            </p>
          )}
        </div>

        {/* Question 9 */}
        <div className="mb-8">
          <button
            onClick={() => toggleAnswer(8)}
            className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
          >
            Are There Any Cancellation Charges?
          </button>
          {openIndex === 8 && (
            <p className="mt-2 text-gray-600 px-4">
              AddMeCart Takes No Charges For Order Cancellation!
            </p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FAQ;
